import React, { FunctionComponent, useEffect, useState, } from 'react'
import { useTranslation } from 'react-i18next';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import { ChevronRight } from '@mui/icons-material';

import './Dashboard.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { Client, supportedClients } from '../../clients';

import { Button, CircularProgress } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { push } from '@lagunovsky/redux-react-router';
import { fetchRelevantApps, } from './dashboard';

interface Props {
}

const Dashboard:FunctionComponent<Props> = ( props ) => {

  const { t } = useTranslation( [ 'dashboard' ] );

  const dispatch = useDispatch<AppDispatch>();

  const lang = useSelector( ( state: RootState ) => state.app.searchParameters.lang );
  const relevantApps = useSelector( ( state: RootState ) => state.pages.dashboard.relevantApps );
  const relevantAppsLoaded = useSelector( ( state: RootState ) => state.pages.dashboard.loading );

  const [ loading, setLoading ] = useState( false )
  const [ loadings, setLoadings ] = useState<boolean[]>( new Array( supportedClients.length )
    .fill( false ) );

  // True app list: compare what we get from the backend with relevantAppIdentifier in supportedClients
  const apps = supportedClients
    .filter( ( { relevantAppIdentifier } ) => relevantApps
    .find( ( { name } ) => relevantAppIdentifier === name ) )
    .sort((a, b) => a.rank - b.rank);

  // Get list of relevant apps from endpoint
  useEffect( () => {
    dispatch( fetchRelevantApps() );
  }, [] );


  // If list has only 1 item and loading is complete: Redirect automatically
  // user does not need to do additional action
  useEffect( () => {
    if( apps.length === 1 && relevantAppsLoaded === 'succeeded' && !apps[0].showDashBoardWhenOnlyOption  ) {
      redirectClient( apps[ 0 ] );
    }
  }, [ apps, relevantApps ] );


  const redirectClient = ( client: Client, index?: number ) => {

    const uri = client.fallbackUri( lang, navigator.userAgent );
    console.log( client.name, uri  );

    // this needs to work when index is 0. 0 is a valid index
    if( index || index === 0 ) setLoadings( loadings.map( ( value, i ) => i === index ? true : false ) );
    setLoading( true );


    window.setTimeout( () => {

      setLoadings( loadings.map( () => false ) );
      setLoading( false );

    }, 8000 );

    const a = document.createElement( 'a' );
    a.target = '_self';
    a.href = uri;
    a.click();
  }

  const onLogout = () => {
    dispatch( push('/sign-out') );
  }

  const onUserProfile = () => {
    dispatch( push('/settings') );
  }

  // With 0 clients in apps list: show dashboard with user profile link and logout button
  // Also with just 1 client because we intent to redirect user automatically
  return (
    ( relevantAppsLoaded !== 'succeeded' || ( apps.length === 1 && !apps[0].showDashBoardWhenOnlyOption ) )
    ? <AuthLayout header={ false } footer={ false }><CircularProgress></CircularProgress></AuthLayout> :
    <AuthLayout header={ true }>
      <div className="page page-dashboard">
        <p>{ t( 'lead' ) }</p>

        <div className="page-dashboard__apps">
          { apps.map( ( client, index ) => (
            <LoadingButton
              onClick= { () => redirectClient( client, index ) }
              type="button"
              loading={ loadings[ index ] === true }
              variant='text'
              disabled={ loading }
              key={ index }
              title={ client.extendedName }
              fullWidth
              sx={ {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                color: 'black',
                fontSize: '1rem',
                fontWeight: 600,
                borderTop: '1px solid #e0e0e0',
                borderRadius: 0,
                paddingTop: 'var( --hgs-spacer-md )',
                paddingBottom: 'var( --hgs-spacer-md )',
                textTransform: 'initial',
                letterSpacing: '.05rem',
              } }
            >{ client.extendedName }<ChevronRight /></LoadingButton>
          ) ) }
        </div>
        <div
          className="dashboard__actions"
        >
          <Button
            className="dashboard__user-profile"
            onClick={ onUserProfile }
            fullWidth
            disabled={ loading }
            variant="contained"
            color="primary"
          >
            { t( 'userProfile' ) }
          </Button>
          <Button
            variant='text'
            type="submit"
            fullWidth
            disabled={ loading }
            onClick={ onLogout }
          >
          { t( 'logout' ) }
          </Button>
        </div>
      </div>
    </AuthLayout>)

}

export default Dashboard;
